var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-panel"},[_c('div',{staticClass:"text-center image"},[_c('a',{attrs:{"href":this.$urlBase + '/inicio',"border":"0"}},[_c('img',{attrs:{"src":_vm.usuarioLogado.Loja.caminho_logomarca,"width":"150","alt":_vm.usuarioLogado.Loja.nome}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }